import { render, staticRenderFns } from "./OldNavbar.vue?vue&type=template&id=523151b6"
import script from "./OldNavbar.vue?vue&type=script&lang=js"
export * from "./OldNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523151b6')) {
      api.createRecord('523151b6', component.options)
    } else {
      api.reload('523151b6', component.options)
    }
    module.hot.accept("./OldNavbar.vue?vue&type=template&id=523151b6", function () {
      api.rerender('523151b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/layouts/OldNavbar.vue"
export default component.exports